import { Button, WithTheme } from '@mint/ui';
import { AdminModalButtonFooterProps } from './admin-modal-button-footer-props';
import { AdminModalFooter } from '../admin-modal-footer';
import React from 'react';
import styled from 'styled-components';

type ComponentType = React.FunctionComponent<
  WithTheme<AdminModalButtonFooterProps>
>;

export const AdminModalButtonFooter = styled<ComponentType>(AdminModalFooter)`
  border-top: 1px solid ${props => props.theme.palette.divider};
  display: flex;
  justify-content: flex-end;
  padding-top: 0.75rem;

  ${Button} {
    margin-left: 0.5rem;
  }
`;
